import { getMarketingCode } from 'src/bff/get-marketing-code';
import { DealersInfo, FormDataGroup, Offer } from 'src/types';
import { formatHeaders } from '../../format-fields';
import { isOfertasForm } from '../LeadGenericoForm';

export const getOfertasData = async (formData: FormDataGroup, dealersInfo: DealersInfo) => {
  const { fields } = formData;
  const { oferta } = dealersInfo;

  if (!isOfertasForm(fields.formName)) {
    return null;
  } else {
    const headers = {
      COD_FORM_ID: 'vw-oneform-lead-oferta',
    };
    const { fields: marketingCodeFields } = await getMarketingCode(oferta.marketingCode);

    const ofertaFields = {
      ...marketingCodeFields,
      'fields[COD_INTEREST_CARLINE]': oferta.carlineCode,
      'fields[DESC_INTEREST_CARLINE]': `${oferta.carlineNuevo ? 'Nuevo ' : ''}${oferta.carlineTitle}`,
      'fields[DESC_FINANCIAL_PRODUCT]': oferta.financiacionText?.slice(4),
      'fields[DESC_VEH_OFFER]': createOfferPrice(oferta),
      'fields[M_OBSERVATION_BRAND]': getObservationBrand(oferta),
    };

    return { ...formatHeaders(headers), ...ofertaFields };
  }
};

export const getOfertasComercialesData = async (formData: FormDataGroup, dealersInfo: DealersInfo) => {
  const { fields } = formData;
  const { oferta } = dealersInfo;

  if (!isOfertasForm(fields.formName)) {
    return null;
  } else {
    const headers = {
      COD_FORM_ID: 'vw-oneform-lead-oferta',
    };
    const { fields: marketingCodeFields, response } = await getMarketingCode(oferta.marketingCode);

    const salesgroup = marketingCodeFields ? marketingCodeFields['fields[COD_VEH_SALESGROUP]'] : '';
    const ofertaFields = {
      'fields[COD_INTEREST_CARLINE]': oferta.carlineCode,
      'fields[DESC_INTEREST_CARLINE]': `${oferta.carlineNuevo ? 'Nuevo ' : ''}${oferta.carlineTitle}`,
      'fields[DESC_FINANCIAL_PRODUCT]': oferta.financiacionText.slice(4),
      'fields[DESC_MODEL_OF_INTEREST]': `${response?.consolidatedData?.salesgroupName}`,
      'fields[DESC_MODEL_OF_INTEREST_2]': `${response?.consolidatedData?.salesgroupName} - ${oferta.financiacionText.replace('con ', '')} - ${oferta.modalidad} ${oferta.cuotaText}`, // CONSULTAR
      'fields[CODE_MODEL_VERSION]': `${oferta.carlineCode}_${salesgroup}`, // FALTA CONCATENAR CON EL SALESGROUP
      'fields[DESC_LOPD]': 'PERMITE',

      'fields[DESC_VEH_OFFER]': createOfferPrice(oferta),
    };

    return { ...formatHeaders(headers), ...ofertaFields };
  }
};

const createOfferPrice = (offer: Offer) => {
  return `Cuota: ${offer.cuota} Eur / \r\nPeriodicidad Cuota: ${offer.cuotaTipo} / \r\nNum Cuotas: ${offer.ncuotas
    } / \r\nEntrada: ${offer.entrada} Eur / \r\nCuota final: ${offer.cuotaFinal} Eur ${offer.tin || offer.tae ? '/' : ''
    }\r\n${offer.tin ? `TIN: ${offer.tin}% ${offer.tae ? '/ \r\n' : '\r\n'}` : ''}${offer.tae ? `TAE: ${offer.tae}%\r\n` : ''
    }`;
};

const getObservationBrand = (oferta: Offer) => {
  if (!oferta.promociones || oferta.promociones.length === 0) {
    return null;
  }

  return oferta.promociones.map((promo) => promo.name);
};
